import { connect } from 'react-redux';
import {
  authorizationsToActivate,
  authorizationsToDeactivate,
  setActivationDialogOpen,
  setConfirmDialogOpen,
  setConfirmDialogType,
  setSelectedAuthorizations,
} from '../store/customerAuthorizationSlice';
import ActionBar from './ActionBar';

const mapState = state => ({
  authorizationsToActivate: authorizationsToActivate(state),
  authorizationsToDeactivate: authorizationsToDeactivate(state),
  customerAuthorizations: state.loadingManagement.customerAuthorizations.customerAuthorizations,
  selectedAuthorizations: state.loadingManagement.customerAuthorizations.selectedAuthorizations,
});

const mapDispatchToProps = {
  setActivationDialogOpen,
  setConfirmDialogOpen,
  setConfirmDialogType,
  setSelectedAuthorizations,
};

export default connect(mapState, mapDispatchToProps)(ActionBar);
